// libs
import React, { useState, memo } from 'react';

// global components
import Logo from 'shared/components/Logo';
import Loader from 'shared/components/Loader';

// redux store
import { setData as _setData } from 'shared/store/internationalization/services';

// constants
import { TEXT } from './constants';

// styles
import {
  LogoCnt,
  Modal,
  Dropdown,
  Content,
  InnerContent,
  Heading,
  ListHeading,
  modalInnerClassName,
  Countries,
  Para,
  Label,
  Button,
  MoreLink,
  ShippingInfo,
} from './styles';

// defs
interface ISelectionValues {
  name: string;
  value: string;
}

interface IInternationalizationProps {
  hide: () => void;
  openDialog: boolean;
  countries: ISelectionValues[];
  currencies: ISelectionValues[];
  userI18N: {
    countryCode: string;
    country: string;
    currency: string;
    currencyDisplayValue: string;
  };
  setData: typeof _setData;
  isLoading: boolean;
}

function Internationalization({
  hide,
  openDialog,
  countries,
  currencies,
  userI18N,
  setData,
  isLoading,
}: IInternationalizationProps) {
  const [currency, setCurrency] = useState(userI18N.currency);
  const [countryCode, setCountry] = useState(userI18N.countryCode);

  const onSave = () => {
    if (userI18N.currency === currency && userI18N.countryCode === countryCode) {
      hide();
      return;
    }

    const countryname = countries.filter((country) => country.value === countryCode)[0].name;

    const body = {
      curr: currency,
      countrycode: countryCode,
      countryname,
    };

    setData(body).then(() => {
      window.scrollTo(0, 0);
      window.location.reload();
    });
  };

  if (openDialog === false) {
    return null;
  }

  return (
    <Modal innerClassName={modalInnerClassName} onHide={hide}>
      {isLoading && <Loader />}
      <article>
        <LogoCnt>
          <Logo className="header-logo-svg" />
        </LogoCnt>

        <Content>
          <InnerContent>
            <Heading>{TEXT.HEADING}</Heading>
            <Countries>{TEXT.COUNTRIES_SUPPORTED}</Countries>
            <Para>
              <Label className="label">{TEXT.LABELS.SHOPTO}</Label>
            </Para>
            <div data-test="dropdown-country">
              <Dropdown
                list={countries}
                selectedValue={userI18N.countryCode}
                // @ts-ignore
                onSelect={({ value }) => setCountry(value)}
              />
            </div>
            <Para>
              <Label className="label">{TEXT.LABELS.SHOPIN}</Label>
            </Para>
            <div data-test="dropdown-currency">
              <Dropdown
                list={currencies}
                selectedValue={userI18N.currency}
                // @ts-ignore
                onSelect={({ value }) => setCurrency(value)}
              />
            </div>

            <Button onClick={onSave} data-test="i18n-submit">
              {TEXT.BUTTONS.SAVE}
            </Button>
            <div>
              <Para>{TEXT.QUESTIONS_GUIDE}</Para>
              <Para>
                <MoreLink href="/lp/shipping-and-return-policy">{TEXT.MORE_INFO_LINK}</MoreLink>
              </Para>
            </div>
          </InnerContent>
          <InnerContent>
            <ListHeading>{TEXT.LISTING_HEADER}</ListHeading>
            <ShippingInfo>
              <li>{TEXT.SHIPPING_INFO[0]}</li>
              <li>{TEXT.SHIPPING_INFO[1]}</li>
              <li>{TEXT.SHIPPING_INFO[2]}</li>
            </ShippingInfo>
          </InnerContent>
        </Content>
      </article>
    </Modal>
  );
}

export default memo(Internationalization);
